module.exports = __webpack_public_path__ + "static/img/19.26d3fe20.png";